import React, {FC, useState} from 'react';
import {DataSource} from "../../constants/DataSource/DataSource";
import {RequestIntegration} from "./Items/RequestIntegration";
import {YML} from "./Items/YML/YML";
import {DataSourceStatus} from "../../constants/DataSource/DataSourceStatus";
import {DmitrovkaResantagroupRu} from "./Items/DmitrovkaResantagroupRu";
import {Warehouse} from "./Items/Warehouse/Warehouse";
import {GoogleSheet} from "./Items/GoogleSheet/GoogleSheet";
import {P5S} from "./Items/P5S";
import {Levenhuk} from "./Items/Levenhuk/Levenhuk";
import {Avantmarket} from "./Items/Avantmarket/Avantmarket";
import {EmailCSV} from "./Items/EmailCSV/EmailCSV";
import {EmailExcel} from "./Items/EmailExcel/EmailExcel";
import {UrlExcel} from "./Items/UrlExcel/UrlExcel";

interface DataSourcesProps {
  data: DataSource[]
  updateDataHandler: (data: DataSource[]) => void
  whID: string
}

const DataSources: FC<DataSourcesProps> = ({data, updateDataHandler, whID}) => {

  interface IItemState {
    code: string
    isDisclosed: boolean
    isActive: boolean
    resyncedAt: number|null
  }

  const initialItemsState = [
    {isDisclosed: false, isActive: false, resyncedAt: null, code: 'yml'},
    {isDisclosed: false, isActive: false, resyncedAt: null, code: 'googleSheet'},
    {isDisclosed: false, isActive: false, resyncedAt: null, code: 'emailCSV'},
    {isDisclosed: false, isActive: false, resyncedAt: null, code: 'emailExcel'},
    {isDisclosed: false, isActive: false, resyncedAt: null, code: 'urlExcel'},
    {isDisclosed: false, isActive: false, resyncedAt: null, code: 'warehouse'},
    {isDisclosed: false, isActive: false, resyncedAt: null, code: 'dmitrovkaResantagroupRu'},
    {isDisclosed: false, isActive: false, resyncedAt: null, code: 'p5s'},
    {isDisclosed: false, isActive: false, resyncedAt: null, code: 'levenhuk'},
    {isDisclosed: false, isActive: false, resyncedAt: null, code: 'avantmarket'},
    {isDisclosed: false, isActive: false, resyncedAt: null, code: 'requestIntegration'},
  ];

  const [itemsState, setItemsState] = useState<IItemState[]>(initialItemsState);

  function resyncItem(code: string) {
    const updateItems = (collection: any, item: IItemState) => {
      return [
        ...collection,
        {
          ...item,
          resyncedAt: item.code === code ? (new Date()).getTime() + ((new Date()).getMilliseconds() / 1000) : item.resyncedAt,
        },
      ]
    };

    setItemsState((prevState) => prevState.reduce(updateItems, []));
  }

  function toggleIsDisclosed(code: string) {
    const updateItems = (collection: any, item: IItemState) => {
      return [
        ...collection,
        {
          ...item,
          isDisclosed: item.code === code ? !item.isDisclosed : item.isDisclosed,
        },
      ]
    };

    setItemsState((prevState) => prevState.reduce(updateItems, []));
  }

  function toggleItemStatus(code: string, isActive: boolean) {

    // Toggle status
    for (let obj of data) {
      obj.status = obj.code === code ? (isActive ? DataSourceStatus.Current : DataSourceStatus.Archived) : DataSourceStatus.Archived
    }
    updateDataHandler(data)
    console.log("item status change to", code, (isActive ? DataSourceStatus.Current : DataSourceStatus.Archived))

    const updateItems = (collection: any, item: IItemState) => {
      return [
        ...collection,
        {
          ...item,
          isActive: item.code === code ? isActive : false,
        },
      ]
    };

    setItemsState((prevState) => prevState.reduce(updateItems, []));
  }

  function isItemDisclosed(code: string): boolean {
    return itemsState.find(i => i.code === code)?.isDisclosed || false
  }

  function getDataSourceDTO(code: string): DataSource|null {
    return data?.find(i => i.code === code) || null
  }

  function updateDataSourceHandler(code: string, payload: DataSource|null) {
    if (data && !payload) {
      data.forEach((v, i) => {
        if (v.code === code) {
          data.splice(i, 1);
          console.log('rm ds row')
        }
      })


    } else if (payload) {
      let isUpdated = false
      for (let obj of data) {
        if (obj.code === code) {
          obj = payload
          isUpdated = true
          console.log('updated ds row')
          break
        }
      }
      if (!isUpdated) {
        console.log('add new ds row')
        data.push(payload)
      }
    }

    console.log('DataSources. updateDataSourceHandler: ', data, code)
    updateDataHandler(data)
    resyncItem(code)
  }

  const renderItem = (i: IItemState, k: number) => {
    const ds = getDataSourceDTO(i.code)
    i.isActive = i.isActive || ds?.status === DataSourceStatus.Current
    switch (i.code) {
      case 'yml':
        return <YML
            key={k}
            code={i.code}
            data={ds}
            updateDataSourceHandler={updateDataSourceHandler}
            toggleIsDisclosed={toggleIsDisclosed}
            toggleItemStatus={toggleItemStatus}
            isDisclosed={i.isDisclosed}
            isActive={i.isActive}
        />;

      case 'googleSheet':
        return <GoogleSheet
            key={k}
            code={i.code}
            data={ds}
            updateDataSourceHandler={updateDataSourceHandler}
            toggleIsDisclosed={toggleIsDisclosed}
            toggleItemStatus={toggleItemStatus}
            isDisclosed={i.isDisclosed}
            isActive={i.isActive}
        />;

      case 'emailCSV':
        return <EmailCSV
            key={k}
            code={i.code}
            data={ds}
            updateDataSourceHandler={updateDataSourceHandler}
            toggleIsDisclosed={toggleIsDisclosed}
            toggleItemStatus={toggleItemStatus}
            isDisclosed={i.isDisclosed}
            isActive={i.isActive}
        />;

      case 'emailExcel':
        return <EmailExcel
            key={k}
            code={i.code}
            data={ds}
            updateDataSourceHandler={updateDataSourceHandler}
            toggleIsDisclosed={toggleIsDisclosed}
            toggleItemStatus={toggleItemStatus}
            isDisclosed={i.isDisclosed}
            isActive={i.isActive}
        />;

      case 'urlExcel':
        return <UrlExcel
            key={k}
            code={i.code}
            data={ds}
            updateDataSourceHandler={updateDataSourceHandler}
            toggleIsDisclosed={toggleIsDisclosed}
            toggleItemStatus={toggleItemStatus}
            isDisclosed={i.isDisclosed}
            isActive={i.isActive}
        />;

      case 'warehouse':
        return <Warehouse
            key={k}
            code={i.code}
            data={ds}
            updateDataSourceHandler={updateDataSourceHandler}
            toggleIsDisclosed={toggleIsDisclosed}
            toggleItemStatus={toggleItemStatus}
            isDisclosed={i.isDisclosed}
            isActive={i.isActive}
            whID={whID}
        />;

      case 'p5s':
        return <P5S
            key={k}
            code={i.code}
            data={ds}
            updateDataSourceHandler={updateDataSourceHandler}
            toggleIsDisclosed={toggleIsDisclosed}
            toggleItemStatus={toggleItemStatus}
            isDisclosed={i.isDisclosed}
            isActive={i.isActive}
        />;

      case 'dmitrovkaResantagroupRu':
        return <DmitrovkaResantagroupRu
            key={k}
            code={i.code}
            data={ds}
            updateDataSourceHandler={updateDataSourceHandler}
            toggleIsDisclosed={toggleIsDisclosed}
            toggleItemStatus={toggleItemStatus}
            isDisclosed={i.isDisclosed}
            isActive={i.isActive}
        />;

      case 'levenhuk':
        return <Levenhuk
            key={k}
            code={i.code}
            data={ds}
            updateDataSourceHandler={updateDataSourceHandler}
            toggleIsDisclosed={toggleIsDisclosed}
            toggleItemStatus={toggleItemStatus}
            isDisclosed={i.isDisclosed}
            isActive={i.isActive}
        />;

      case 'avantmarket':
        return <Avantmarket
            key={k}
            code={i.code}
            data={ds}
            updateDataSourceHandler={updateDataSourceHandler}
            toggleIsDisclosed={toggleIsDisclosed}
            toggleItemStatus={toggleItemStatus}
            isDisclosed={i.isDisclosed}
            isActive={i.isActive}
        />;

      case 'requestIntegration':
        return <RequestIntegration
            key={k}
            code={i.code}
            toggleIsDisclosed={toggleIsDisclosed}
            isDisclosed={i.isDisclosed}
        ></RequestIntegration>;
    }
  };

  return (
      <>
        {itemsState.map(renderItem)}
      </>
  );
};

export default DataSources;
